import { useTranslation } from 'react-i18next'

import { useDeletePackage } from '@/api/packages/delete-package'
import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils'

export interface DeletePackageModalProps {
  packageId: number
  onClose: () => void
}

export const DeletePackageModal = ({ packageId, onClose }: DeletePackageModalProps) => {
  const { t } = useTranslation(['packages'])
  const { mutateAsync: deletePackage, isPending } = useDeletePackage()

  const handleConfirm = async () => {
    try {
      await deletePackage({ id: packageId })
      toastFactory.success(t('packages:deletePackageModal.toastSuccess'))
      onClose()
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
  }

  return (
    <ConfirmationPopup
      title={t('packages:deletePackageModal.title')}
      confirmText={t('packages:deletePackageModal.confirm')}
      cancelText={t('packages:deletePackageModal.cancel')}
      variant="danger"
      closeable={!isPending}
      closeOnOverlayClick={!isPending}
      closeOnEscapeKey={!isPending}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      {t('packages:deletePackageModal.body', { packageId })}
    </ConfirmationPopup>
  )
}
